import { createContext } from 'react';

export type CollapsibleContextValue = {
    clipped: boolean | undefined;
    setClipped: (clipped: boolean) => void;
};

export const CollapsibleContext = createContext<CollapsibleContextValue>({
    clipped: undefined,
    setClipped: () => undefined,
});
